module.exports = "/images/Masonry---Hero.jpg";